<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Penomoran Surat Tugas Penguji
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row class="mb-2 mt-2">
        <b-col
          cols="12"
          md="12"
          class="mb-md-0 mb-2"
        >
          <h5>Total surat tugas penguji yang belum diberi nomor : {{ total_surat_tugas }}</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Dari</label>
          <b-form-input 
            v-model="filter.dari_nomor_surat"
            placeholder="Dari Nomor"
            :type="'number'"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Sampai</label>
          <b-form-input 
            v-model="filter.sampai_nomor_surat"
            placeholder="Sampai Nomor"
            :type="'number'"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="proses()" v-if="total_surat_tugas != 0" :disabled="show == 1">Proses</b-button>
        </b-col>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
        <b-spinner
        :variant="'dark'" v-if="show == 1"
        ></b-spinner>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getJenisSidang,
  getStatusJadwalSidang,
  getSuratTugasPengujiTanpaNomor,
  postProsesNomorSuratTugasPenguji,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
    BSpinner,
  },
  data() {
    return {
      show: 0,
      filter: {},
      total_surat_tugas: 0,
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusJadwalOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Jadwal Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
    getSuratTugasPengujiTanpaNomor()
      .then(response => {
        if (response.data.success == true) {
          this.total_surat_tugas = response.data.data
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    proses() {
      this.show = 1
      postProsesNomorSuratTugasPenguji(this.filter)
      .then(response => {
        if (response.data.success == true) {
          this.show = 0
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Nomor Surat tugas',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil diperoses, Silahkan tunggu beberapa saat kemudian cek kembali pada menu surat tugas.',
            },
          })
          this.$emit('reload')
          this.filter.dari_nomor_surat = null
          this.filter.sampai_nomor_surat = null
          this.$router.go(0)
        }
      })
      .catch(error => {
        this.show = 0
      });
    },
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
